<footer class="footer-container">
  <div class="footer px-3 py-4 px-md-4 py-md-5">
    <div class="container-fluid p-0">
      <div class="row gy-4 gx-4 gx-lg-5 gx-xl-6">
        <div class="col-lg-3 col-12 mb-3 footer-brand-col">
          <a class="navbar-brand d-flex align-items-center col-md-6" href="/">
            <img
              class="udaan-logo img-fluid"
              src="/assets/images/logo/uddan-logo.svg"
              alt="Udaan logo"
            />
          </a>

          <p class="footer-text my-3">
            {{ siteSettingsState().siteSettings?.footer?.description || "N.A" }}
          </p>

          <div class="review-logos d-flex flex-wrap align-items-center gap-5">
            <img
              class="review-logo"
              src="/assets/images/logo/trip-advisor-2023.svg"
              alt="Trip Advisor 2023"
            />
            <img
              class="review-logo"
              src="/assets/images/logo/trip-advisor-2024.svg"
              alt="Trip Advisor 2024"
            />
            <img
              class="review-logo"
              src="/assets/images/logo/trip-advisor-2025.svg"
              alt="Trip Advisor 2025"
            />
          </div>
        </div>

        <hr class="footer-hr mt-2 d-block d-md-none" />

        <div class="col-6 col-md-3 col-lg-2 mobile-links-col">
          <h6 class="footer-heading">
            {{
              siteSettingsState().siteSettings?.footer?.secondCols?.heading ||
                "N.A"
            }}
          </h6>
          <ul class="footer-list">
            @for (
              item of siteSettingsState().siteSettings?.footer?.secondCols
                ?.links;
              track $index
            ) {
              <li>
                <a
                  [href]="item?.linkUrl"
                  target="_blank"
                  rel="noopener"
                  class="footer-link"
                >
                  {{ item?.displayText }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="col-6 col-md-3 col-lg-2 mobile-links-col">
          <h6 class="footer-heading">
            {{
              siteSettingsState().siteSettings?.footer?.thirdCols?.heading ||
                "N.A"
            }}
          </h6>
          <ul class="footer-list">
            @for (
              item of siteSettingsState().siteSettings?.footer?.thirdCols
                ?.links;
              track $index
            ) {
              <li>
                <a
                  [href]="item?.linkUrl"
                  target="_blank"
                  rel="noopener"
                  class="footer-link"
                >
                  {{ item?.displayText }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="col-6 col-md-3 col-lg-2 mobile-links-col">
          <h6 class="footer-heading">
            {{
              siteSettingsState().siteSettings?.footer?.fourthCols?.heading ||
                "N.A"
            }}
          </h6>
          <ul class="footer-list">
            @for (
              item of siteSettingsState().siteSettings?.footer?.fourthCols
                ?.links;
              track $index
            ) {
              <li>
                <a
                  [href]="item?.linkUrl"
                  target="_blank"
                  rel="noopener"
                  class="footer-link"
                >
                  {{ item?.displayText }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="col-6 col-md-6 col-lg-3 reservations-col">
          <h6 class="footer-heading">Reservations</h6>
          <small class="footer-text mt-2 reservations-text">
            <a href="tel:919555033033" target="_blank">+91 9555 033 033</a>
          </small>

          <div class="d-none d-md-block mt-4">
            <hr class="footer-hr" />
            <h6 class="footer-heading mb-2 mt-2">Subscribe</h6>

            <div class="newsletter">
              <form
                action="https://udaanhotels.us12.list-manage.com/subscribe/post?u=5e3708bd615a39116dc0cc767&id=4a6f7f84e8&f_id=007dc3e8f0"
                method="post"
                target="_blank"
                novalidate
              >
                <div class="newsletter-input">
                  <input
                    type="email"
                    name="EMAIL"
                    placeholder="Email Address"
                    required
                  />
                  <button
                    type="submit"
                    class="newsletter-btn"
                    aria-label="Subscribe"
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>

                <div
                  style="position: absolute; left: -5000px"
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="b_5e3708bd615a39116dc0cc767_4a6f7f84e8"
                    tabindex="-1"
                    value=""
                  />
                </div>

                <small class="newsletter-hint">
                  Enter your email address for promotions and news.
                </small>
              </form>
            </div>
          </div>
        </div>

        <hr class="footer-hr mt-2 d-block d-md-none" />
        <div class="col-12 d-block d-md-none mobile-newsletter-col mobile-links-col">
          <h6 class="footer-heading  mb-2 mt-2">Newsletter</h6>
          <small class="newsletter-hint mobile-newsletter-copy d-block mb-3">
            Subscribe To Our Newsletter To Get Your Weekly Updates, Tips And Special Offers.
          </small>

          <div class="newsletter">
            <form
              action="https://udaanhotels.us12.list-manage.com/subscribe/post?u=5e3708bd615a39116dc0cc767&id=4a6f7f84e8&f_id=007dc3e8f0"
              method="post"
              target="_blank"
              novalidate
            >
              <div class="newsletter-input">
                <input
                  type="email"
                  name="EMAIL"
                  placeholder="Email Address"
                  required
                />
                <button
                  type="submit"
                  class="newsletter-btn"
                  aria-label="Subscribe"
                >
                  <i class="fa-solid fa-arrow-right"></i>
                </button>
              </div>

              <div
                style="position: absolute; left: -5000px"
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_5e3708bd615a39116dc0cc767_4a6f7f84e8"
                  tabindex="-1"
                  value=""
                />
              </div>
            </form>
          </div>
        </div>

        <hr class="footer-hr mt-2 d-block d-md-none" />
        <div class="col-12 follow-section mb-2">
          <h6 class="footer-heading">FOLLOW US ON</h6>
          <div class="d-flex gap-3 image-bank">
            <!-- <span class="d-none d-md-inline-flex">
              <a
                href="https://x.com/UdaanHotels/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/social-media/twitter.svg"
                  alt="Twitter"
                />
              </a>
            </span> -->
            <span>
              <a
                href="https://www.instagram.com/udaanhotels/#"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/social-media/instagram.svg"
                  alt="Instagram"
                />
              </a>
            </span>
            <span>
              <a
                href="https://www.linkedin.com/company/udnhtls/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/social-media/linkdin.svg"
                  alt="LinkedIn"
                />
              </a>
            </span>
            <span>
              <a
                href="https://www.facebook.com/udaanhotels"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/social-media/facebook.svg"
                  alt="Facebook"
                />
              </a>
            </span>
            <span>
              <a
                href="https://www.youtube.com/@udaanhotels"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/social-media/youtube.svg"
                  alt="Youtube"
                />
              </a>
            </span>
          </div>
        </div>

        <hr class="footer-hr mt-2" />

        <div class="col-12 p-0 footer-margin-fix">
          <div class="footer-bottom text-center py-1">
            <h3 class="copyright mb-0">
              Copyright © 2025 Udaan Hotels &amp; Resorts Pvt.Ltd.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>